/**
 * Copies and deeply freezes the structural report envelope.
 *
 * Report records contain scalar facts and references only; migration functions,
 * complete documents and metadata are deliberately excluded.
 */
export function createPlotJsonMigrationReport(input) {
    return Object.freeze({
        sourceSchemaVersion: input.sourceSchemaVersion,
        targetSchemaVersion: input.targetSchemaVersion,
        documentSteps: Object.freeze(input.documentSteps.map(freezeDocumentStep)),
        featureSteps: Object.freeze(input.featureSteps.map(freezeFeatureRecord)),
        normalizations: Object.freeze(input.normalizations.map(freezeNormalization)),
        warnings: Object.freeze(input.warnings.map(freezeWarning)),
    });
}
function freezeDocumentStep(input) {
    return Object.freeze({
        scope: "document",
        sourceVersion: input.sourceVersion,
        targetVersion: input.targetVersion,
    });
}
function freezeDefinitionStep(input) {
    return Object.freeze({
        scope: "definition",
        featureId: input.featureId,
        from: freezeReference(input.from),
        to: freezeReference(input.to),
    });
}
function freezeFeatureRecord(input) {
    return Object.freeze({
        featureId: input.featureId,
        source: freezeReference(input.source),
        target: freezeReference(input.target),
        steps: Object.freeze(input.steps.map(freezeDefinitionStep)),
    });
}
function freezeNormalization(input) {
    return Object.freeze({
        code: input.code,
        path: input.path,
        ...(input.featureId === undefined
            ? {}
            : { featureId: input.featureId }),
        ...(input.plotType === undefined ? {} : { plotType: input.plotType }),
    });
}
function freezeWarning(input) {
    return Object.freeze({
        code: input.code,
        path: input.path,
        ...(input.featureId === undefined
            ? {}
            : { featureId: input.featureId }),
        ...(input.plotType === undefined ? {} : { plotType: input.plotType }),
    });
}
function freezeReference(input) {
    return Object.freeze({
        plotType: input.plotType,
        definitionVersion: input.definitionVersion,
    });
}
//# sourceMappingURL=plotjson-migration-report.js.map